import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ranges } from '@paige/admin';
import { CustomerPage } from '../screens/admin/CustomerPage';

/** The page's one range for every chart lives in the URL, so a link shows what you saw. */
const searchSchema = z.object({ range: z.enum(ranges).optional() });

/** Level 0, screen 4: the customer page. */
export const Route = createFileRoute('/admin/customers/$tenant')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <CustomerPage tenantId={Route.useParams().tenant} />;
}
